import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DataService } from '../../common-services/data.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() pageType: any;
  @Output() searchItem = new EventEmitter<any>();
  placeHolder: any;
  search = new FormControl('');
  private _subscription: Subscription;
  private _obs: Subscription;

  constructor(private _dataService: DataService) {
    this._subscription = this._dataService?.events?.subscribe((res: any) => {
      if (res.name === 'clearFilter') {
        this.search.reset();
      }
    });
  }

  ngOnInit(): void {
    switch (this.pageType) {
    case 'people':
      this.placeHolder = 'Name/Email/EmpId';
      break;
    case 'client':
      this.placeHolder = 'Name/Email/Domain/ClientId';
      break;
    case 'developer':
      this.placeHolder = 'Entity ID';
      break;
    default:
      this.placeHolder = 'Search';
    }

    this._obs = this.search.valueChanges
      .pipe(debounceTime(500))
      .subscribe((data) => {
        if (
          data !== null &&
          ((data.length && data.substr(data.length - 1) !== ' ') ||
            !data.length)
        ) {
          this.searchItem.emit(data);
        }
      });
  }

  /**
   * Clears search
   */
  clearSearch() {
    this.search.reset();
    this.searchItem.emit(this.search.value);
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._obs?.unsubscribe();
  }
}
